/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_Translation_JobInputs */

const en_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Translation Job`)
};

const fr_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soumettre ${i?.count} traduction`)
};

const de_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übersetzungsauftrag ${i?.count} einreichen`)
};

const it_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invia lavoro di traduzione ${i?.count}`)
};

const ru_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправить задание на перевод ${i?.count}`)
};

const es_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar trabajo de traducción ${i?.count}`)
};

const zh_cn2_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交 ${i?.count} 翻译任务`)
};

const ja_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 翻訳ジョブを送信`)
};

const hi_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य जमा करें`)
};

const pt_pt2_submit_translation_job = /** @type {(inputs: Submit_Translation_JobInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar trabalho de tradução ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Submit {count} Translation Job" |
*
* @param {Submit_Translation_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_translation_job = /** @type {((inputs: Submit_Translation_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Translation_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submit_translation_job(inputs)
	if (locale === "de") return de_submit_translation_job(inputs)
	if (locale === "it") return it_submit_translation_job(inputs)
	if (locale === "ru") return ru_submit_translation_job(inputs)
	if (locale === "es") return es_submit_translation_job(inputs)
	if (locale === "zh-CN") return zh_cn2_submit_translation_job(inputs)
	if (locale === "ja") return ja_submit_translation_job(inputs)
	if (locale === "hi") return hi_submit_translation_job(inputs)
	if (locale === "pt-PT") return pt_pt2_submit_translation_job(inputs)
	return en_submit_translation_job(inputs)
});